// @ts-strict-ignore
import { IntegrationType } from '../types';
import * as React from 'react';
import { AppBuildComponent, CIBuildComponent } from './BuildComponents';
import Space from 'antd/lib/space';
import LinkageIcon from './icons/LinkageIcon';
interface CIAppStoreBuildComponentProps {
    ciBuildIdentifier: string;
    ciBuildIntegrationId: IntegrationType;
    appStoreBuildIdentifier?: string;
    appStoreBuildIntegrationId?: IntegrationType;
    isAppStoreBuildProcessed: boolean;
    strong?: boolean;
}

const CIAppStoreBuildComponent: React.FC<CIAppStoreBuildComponentProps> = ({
    ciBuildIdentifier,
    ciBuildIntegrationId,
    appStoreBuildIdentifier,
    appStoreBuildIntegrationId,
    isAppStoreBuildProcessed,
    strong = true,
}) => {
    const ciBuildComponent = (
        <CIBuildComponent integrationId={ciBuildIntegrationId} buildIdentifier={ciBuildIdentifier} strong={strong} />
    );
    let appStoreBuildComponent = null;

    if (appStoreBuildIdentifier && appStoreBuildIntegrationId) {
        appStoreBuildComponent = (
            <AppBuildComponent
                integrationId={appStoreBuildIntegrationId}
                buildIdentifier={appStoreBuildIdentifier}
                strong={strong}
                isProcessed={isAppStoreBuildProcessed}
            />
        );
    }

    return (
        <Space align="center">
            {ciBuildComponent}
            {appStoreBuildComponent && ciBuildComponent && <LinkageIcon width={16} height={16} />}
            {appStoreBuildComponent}
        </Space>
    );
};

export default CIAppStoreBuildComponent;
